import React from 'react';
import cx from 'classnames';

import styles from './Flags.module.scss';

export interface Props {
  className?: Parameters<typeof cx>[0];
}

export const EU: React.FC<Props> = ({ className }) => (
  <i className={cx(styles.icon, className)}>
    <svg width={25} height={24} fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g>
        <path d='M24.5 4H.5v16h24V4z' fill='#0052B4' />
        <path
          d='M12.5 7.5l.24.74h.77l-.62.45.24.74-.63-.46-.63.46.24-.74-.62-.45h.77l.24-.74zM9.32 8.82l.69.35.55-.55-.12.77.69.35-.77.12-.12.77-.35-.7-.77.13.55-.55-.35-.69zM8 12l.74-.24v-.77l.45.62.74-.24-.46.63.46.63-.74-.24-.45.62v-.77L8 12zM9.32 15.18l.35-.69-.55-.55.77.12.35-.68.12.76.77.12-.69.35.12.77-.55-.55-.69.35zM12.5 16.5l-.24-.74h-.77l.62-.45-.24-.74.63.46.63-.46-.24.74.62.45h-.77l-.24.74zM15.68 15.18l-.69-.35-.55.55.12-.77-.68-.35.76-.12.12-.76.35.68.77-.12-.55.55.35.69zM17 12l-.74.24v.77l-.45-.62-.74.24.46-.63-.46-.63.74.24.45-.62v.77L17 12zM15.68 8.82l-.35.69.55.55-.77-.13-.35.7-.12-.77-.76-.12.68-.35-.12-.77.55.55.69-.35z'
          fill='#FFDA44'
        />
      </g>
      <path d='M.5 4h24v15.998H.5z' stroke='#111' />
    </svg>
  </i>
);

EU.displayName = 'EU';
export default EU;
